<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let displayNum = 0;

    function interpolate(start, target, durationMS) {
        if (start === target) {
            return;
        }

        const steps = target - start;
        const frameDuration = durationMS / steps;
        const newStart = start + 1;

        displayNum = newStart;

        setTimeout(() => interpolate(newStart, target, durationMS - frameDuration), frameDuration);
    }

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        tl.fromTo(drawLine, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.15,
            duration: 1,
            onStart: () => {
                interpolate(0, 19, 1000)
            },
        });

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_586" data-name="Rectangle 586" width="96.997" height="67.959" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_867" data-name="Rectangle 867" width="380" height="678"/>
    <text id="Who_is_involved_" data-name="Who is involved?" transform="translate(38 50.446)" fill="#fcd0b1"
          font-size="24" font-family="Metric">
        <tspan x="0" y="0">Who is involved?</tspan>
    </text>
    <text id="Head_of_compliance" data-name="Head of compliance" transform="translate(38 100)" fill="#fff"
          font-size="48" font-family="Metric-Bold, Metric" font-weight="700">
        <tspan x="0" y="37">Head of</tspan>
        <tspan x="0" y="89">compliance</tspan>
    </text>
    <text id="_19_" data-name="19%" transform="translate(92 287)" fill="#fff" font-size="86"
          font-family="Metric-Bold, Metric" font-weight="700">
        <tspan x="11.937" y="66">{displayNum}%</tspan>
    </text>
    <g id="Group_1175" data-name="Group 1175" transform="translate(173 230)">
        <g id="Group_1174" data-name="Group 1174" clip-path="url(#clip-path)">
            <path bind:this={drawLine} id="Path_14574" data-name="Path 14574"
                  d="M6.6,6.653c40.469,0,74.236,22.779,89.4,60.306" fill="none" stroke="#008ed2" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14575" data-name="Path 14575" d="M1.2,6.6A5.4,5.4,0,1,1,6.6,12,5.4,5.4,0,0,1,1.2,6.6"
                  fill="#fff"/>
            <path id="Path_14576" data-name="Path 14576" d="M1.2,6.6A5.4,5.4,0,1,1,6.6,12,5.4,5.4,0,0,1,1.2,6.6Z"
                  fill="none" stroke="#100f0c" stroke-miterlimit="10" stroke-width="2.398"/>
        </g>
    </g>
    <text id="of_companies_say_the_head_of_compliance_is_frequently_involved_in_making_strategic_decisions" data-name="of companies say the head of compliance is frequently involved in making
strategic decisions" transform="translate(38 429)" fill="#fff" font-size="24" font-family="Metric">
        <tspan x="0" y="18">of companies say the</tspan>
        <tspan x="0" y="46">head of compliance is</tspan>
        <tspan x="0" y="74">frequently involved in</tspan>
        <tspan x="0" y="102">making strategic</tspan>
        <tspan x="0" y="130">decisions</tspan>
    </text>
</svg>
